import React from 'react'
import styled from 'styled-components'
import  Navbar  from './Navbar/Navbar'
import '../styles/global.css'
import Footer from './Footer'

const Wrapper = styled.div`
max-width: 1900px;
margin: 0 auto;
`
interface LayoutProps {
    children: React.ReactNode,
}

const Layout: React.FC<LayoutProps> = ({children}) => {
        return (
            <Wrapper>
                <Navbar />
                {children}
                <Footer/>
            </Wrapper>
        );
}
export default Layout